module.exports = __webpack_public_path__ + "img/right2@2x.4e516284.png";